import React, { useState, useEffect, useRef } from 'react';
// Adicionado 'Card' nos imports do react-bootstrap
import { Table, Form, Button, Modal, Card } from "react-bootstrap";
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faPlus, faEye, faPen, faToggleOn, faToggleOff, faTrash 
} from '@fortawesome/free-solid-svg-icons';
import useFetch from "../../../hooks/useFetch";
import RequireRoles from '../../../components/RequireRoles';
import PaginatedItems from '../../../components/administracao/Pagination';



function GerenciarItens() {
    const { params } = useParams(); // pega o que vem depois da barra na url
    const { get, del, put, error } = useFetch();

    const defaultState = {
        limpouFiltro: false,
        itens: [],
        count: 0,
        page: 1,
        filtroAtivo: false,
        filtros: {
            ordem: "Alfabetica",
            nome_item: "", apresentacao: "", material: "",
            altura: "", largura: "", comprimento: "", diametro: "",
            profundidade: "", peso: "", sala: "", estante: "", prateleira: "",
            circunferencia: "", forma_aquis: "", dt_entrada: "",
            marcas: "", procedencia: "", origem: "",
            fabricante: "", conservacao: "", restauracao: "",
            n_patrimonial: "", pesquisa: "", solicitacao: "",
            bibliografia: "", historico: "", observacao: ""
        },
        mostrarModal: false,
        registroAExcluir: {
            nome_item: ""
        },
        loading: true,
    };

    // Roda quando a página é carregada https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
    const [state, setState] = useState(() => {
        return defaultState;
    });

    const selectRef = useRef();

    useEffect(() => {
        async function initialize() {
            let [itens, count] = await buscarItens({});
            setState({ ...state, itens: itens, count: count, loading: false });
        }
        initialize();
    }, [params]);

    // função de paginação
    async function handlePageChange(pageNumber) {
        window.scrollTo(0, 0);
        let filtroPaginacao = { page: pageNumber };
        if (state.filtroAtivo) {
            filtroPaginacao = { ...filtroPaginacao, page: pageNumber };
        }
        let [itens, count] = await buscarItens({...filtroPaginacao, ...state.filtros});
        setState({ ...state, page: pageNumber, itens: itens, count: count, loading: false });
    }

    // Busca os dados do banco
    async function buscarItens(filtros) {
        if (!state.loading) setState({ ...state, loading: true });
        // filtros = { nome: "nome", descricao: "descricao" }
        let query = "?";
        if (filtros && Object.keys(filtros).length > 0) {
            for (const key in filtros) {
                if (filtros[key] !== "") {
                    query = query.concat(key, "=", filtros[key], "&");
                }
            }
            // check for ordem in filtros
            if (!filtros.ordem) {
                query = query.concat("ordem=", state.filtros.ordem);
            }
        }
        else {
            query = "?ordem=" + state.filtros.ordem;
        }
        // no fim fica: nome=nome&descricao=descricao&
        try {
            let response = await get('/itemadmin' + query);
            if (response.ok || response.status === 304) {
                let dados = response.result;
                return [dados.data, dados.count];
            }
        } catch (error) {
            console.error('Erro no buscarItens():', error);
        }
    }

    // Função acionada quando o usuário clica em buscar
    async function filtrarItens() {
        // adiciona os dados no objeto filtros se eles não forem vazios
        // Busca os dados do banco com os filtros
        let [itens, count] = await buscarItens(state.filtros);
        // Atualiza o estado com os dados buscados
        setState({ ...state, itens: itens, count: count, filtroAtivo: true, loading: false });
    }

    async function limparFiltros() {
        // Busca os dados do banco sem filtros
        state.ordem = "";
        let [itens, count] = await buscarItens({});
        // Atualiza o estado com os dados buscados e reseta os valores dos campos de filtro
        setState({ ...state, itens: itens, filtros: defaultState.filtros, filtroAtivo: false, count: count, loading: false});
        selectRef.current.value = "";
    }

    function handleChangeFiltros(event) {
        let target = event.target;
        let value = target.value;
        let name = target.name;

        if (target.type === 'select-one') {
            value = target.options[target.selectedIndex].value;
        }

        setState({
            ...state,
            filtros: {
                ...state.filtros,
                [name]: value
            }
        });
    }

    async function handleChangeOrdem(event) {
        let target = event.target;
        let value = target.value;
        let name = target.name;

        state.filtros = {
            ...state.filtros,
            [name]: value
        }

        // Busca os dados do banco com os filtros
        let [itens, count] = await buscarItens(state.filtros);
        // Atualiza o estado com os dados buscados
        setState({
            ...state,
            itens: itens,
            count: count,
            filtroAtivo: true,
            loading: false,
            filtros: {
                ...state.filtros,
                [name]: value
            }
        });
    }

    function confirmarInativacao(item) {
        setState({ ...state, mostrarModalInativacao: true, registroAExcluir: item });
    }

    function confirmarExclusao(item) {
        setState({ ...state, mostrarModalExclusao: true, registroAExcluir: item });
    }

    async function inativarItem() {
        let item = state.registroAExcluir;
        try {
            let rota = item.status_item === "Ativo" ? "/inativaritem/" : "/ativaritem/";
            let response = await put(rota + item.id_item);
            if (response.status === 201) {
                // Precisamos desestruturar [itens, count]
                let [itens, count] = await buscarItens(state.filtros); 
                
                setState({ 
                    ...state, 
                    itens: itens, 
                    count: count, // Atualiza o contador também
                    mostrarModalInativacao: false, 
                    registroAExcluir: { nome_item: "" }, 
                    loading: false 
                });
            } else {
                console.error('Erro no inativarItem()');
            }
        } catch (error) {
            console.error("Erro no inativarItem():", error);
        }
    }

    async function excluirItem() {
        let item = state.registroAExcluir;
        try {
            let response = await del('/item/' + item.id_item);
            if (response.ok) {
                let [itens, count] = await buscarItens(state.filtros);
                setState({ 
                    ...state, 
                    itens: itens, 
                    count: count, 
                    mostrarModalExclusao: false, 
                    registroAExcluir: { nome_item: "" }, 
                    loading: false 
                });
            } else if (error) {
                console.error('Erro no excluirItem()', error);
            }
        } catch (error) {
            console.error("Erro no excluirItem():", error);
        }
    }

    function fecharModal() {
        setState({ ...state, mostrarModalExclusao: false, mostrarModalInativacao: false, registroAExcluir: {} });
    }

    return (
        <div className="admin-page-container">
            {/* Header da Página */}
            <div className="admin-header-container">
                <div className="title-group">
                    <h2 className="admin-title">Itens do Acervo</h2>
                    <p className="admin-subtitle">Gerencie os itens do acervo museológico</p>
                </div>
                <Link to="/admin/itens/criar" className="btn-add-new" state={{ acao: "Criar" }}>
                    <FontAwesomeIcon icon={faPlus} className="me-2" /> Novo Item
                </Link>
            </div>

            {/* Card de Filtros com botões na linha de baixo */}
            <Card className="filter-card-admin mb-4">
                <Card.Body className="p-4">
                    <Form>
                        {/* Linha 1: Campos de Entrada */}
                        <div className="row g-3">
                            <Form.Group className="col-md-4">
                                <Form.Label className="label-admin">Nome do item</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    className="input-moderno" 
                                    placeholder="Buscar por nome..." 
                                    name="nome_item" 
                                    value={state.filtros.nome_item} 
                                    onChange={handleChangeFiltros} 
                                />
                            </Form.Group>
                            <Form.Group className="col-md-2">
                                <Form.Label className="label-admin">Sala</Form.Label>
                                <Form.Control type="text" className="input-moderno" placeholder="Todas" name="sala" value={state.filtros.sala} onChange={handleChangeFiltros} />
                            </Form.Group>
                            <Form.Group className="col-md-3">
                                <Form.Label className="label-admin">Estante</Form.Label>
                                <Form.Control type="text" className="input-moderno" placeholder="Todas" name="estante" value={state.filtros.estante} onChange={handleChangeFiltros} />
                            </Form.Group>
                            <Form.Group className="col-md-3">
                                <Form.Label className="label-admin">Prateleira</Form.Label>
                                <Form.Control type="text" className="input-moderno" placeholder="Todas" name="prateleira" value={state.filtros.prateleira} onChange={handleChangeFiltros} />
                            </Form.Group>
                        </div>

                        {/* Linha 2: Ações e Ordenação */}
                        <div className="d-flex justify-content-between align-items-center mt-4 pt-3 border-top">
                            <div className="d-flex gap-2">
                                <Button className="btn-apply-filters" onClick={filtrarItens}>
                                    Aplicar filtros
                                </Button>
                                <Button className="btn-clear-filters" onClick={limparFiltros}>
                                    Limpar filtros
                                </Button>
                            </div>
                            
                            <div className="d-flex align-items-center gap-2">
                                <span className="text-muted small fw-bold">ORDENAR POR:</span>
                                <Form.Select 
                                    className="small-select w-auto input-moderno" 
                                    name="ordem" 
                                    onChange={handleChangeOrdem} 
                                    value={state.filtros.ordem}
                                >
                                    <option value="Alfabetica">Nome (A-Z)</option>
                                    <option value="Entrada">Data de entrada</option>
                                </Form.Select>
                            </div>
                        </div>
                    </Form>
                </Card.Body>
            </Card>

            {/* Tabela de Itens */}
            <Card className="table-card-admin">
                <div className="table-responsive">
                    <Table className="modern-table mb-0">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Nome</th>
                                <th>Descrição Resumida</th>
                                <th>Sala</th>
                                <th>Estante</th>
                                <th>Prateleira</th>
                                <th>Exposição</th>
                                <th>Status</th>
                                <th className="text-center">Opções</th>
                            </tr>
                        </thead>
                        <tbody>
                            {state.loading ? (
                                <tr>
                                    {/* Ajustado colSpan para 9 colunas */}
                                    <td colSpan="9" className="text-center py-5">
                                        <div className="spinner-border text-teal"></div>
                                        <div className="mt-2 text-muted">Carregando itens...</div>
                                    </td>
                                </tr>
                            ) : state.itens && state.itens.length > 0 ? (
                                state.itens.map((item, index) => (
                                    <tr key={index}>
                                        <td data-label="#" className="text-muted">#{item.id_item}</td>
                                        <td data-label="Nome" className="fw-bold">{item.nome_item}</td>
                                        <td data-label="Descrição" className="text-muted small text-truncate-custom" title={item.apresentacao}>
                                            {item.apresentacao}
                                        </td>
                                        {/* Colunas separadas de volta */}
                                        <td data-label="Sala">{item.sala || '-'}</td>
                                        <td data-label="Estante">{item.estante || '-'}</td>
                                        <td data-label="Prateleira">{item.prateleira || '-'}</td>
                                        <td data-label="Exposição">{item.exposicao || 'Não'}</td>
                                        <td data-label="Status">
                                            <span className={`status-badge ${item.status_item === "Ativo" ? "active" : "inactive"}`}>
                                                {item.status_item}
                                            </span>
                                        </td>
                                        <td data-label="Opções">
                                            <div className="d-flex justify-content-center gap-2">
                                                <Link className="action-icon view" title="Ver Detalhes" to={"/admin/itens/" + item.id_item} state={{ acao: "" }}>
                                                    <FontAwesomeIcon icon={faEye} />
                                                </Link>
                                                <Link className="action-icon edit" title="Editar Item" to={"/admin/itens/" + item.id_item} state={{ acao: "Editar" }}>
                                                    <FontAwesomeIcon icon={faPen} />
                                                </Link>
                                                <button className="action-icon toggle" title="Ativar/Inativar" onClick={() => confirmarInativacao(item)}>
                                                    <FontAwesomeIcon icon={item.status_item === "Ativo" ? faToggleOn : faToggleOff} />
                                                </button>
                                                <RequireRoles allowedRoles={['Desenvolvedor', 'Administrador']}>
                                                    <button className="action-icon delete" title="Excluir Permanentemente" onClick={() => confirmarExclusao(item)}>
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                </RequireRoles>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="9" className="text-center py-4 text-muted">Nenhum item encontrado com esses filtros.</td></tr>
                            )}
                        </tbody>
                    </Table>
                </div>
                <div className="card-footer bg-white border-0 py-3 d-flex justify-content-center">
                    <PaginatedItems itemCount={state.count} itemsPerPage={20} handlePageChange={handlePageChange} />
                </div>
            </Card>

            {/* Modais de Exclusão e Inativação */}
            <Modal show={state.mostrarModalInativacao} onHide={fecharModal} centered>
                <Modal.Header closeButton><Modal.Title>{state.registroAExcluir.status_item === "Ativo" ? "Inativar" : "Ativar"} Item</Modal.Title></Modal.Header>
                <Modal.Body>Deseja alterar o status de <strong>{state.registroAExcluir.nome_item}</strong>?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={fecharModal}>Cancelar</Button>
                    <Button variant="primary" onClick={inativarItem}>Confirmar</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={state.mostrarModalExclusao} onHide={fecharModal} centered>
                <Modal.Header closeButton><Modal.Title>Excluir Item</Modal.Title></Modal.Header>
                <Modal.Body>Tem certeza que deseja excluir permanentemente o item <strong>{state.registroAExcluir.nome_item}</strong>?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={fecharModal}>Cancelar</Button>
                    <Button variant="danger" onClick={excluirItem}>Excluir</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default GerenciarItens;
